var _rect, _path, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    rx: 2.75,
    fill: "#CD6EE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 7.51637C25.875 7.24643 25.6527 7.02759 25.3785 7.02759H8.49653C8.22231 7.02759 8 7.24643 8 7.51637V8.57781C8 8.83708 8.10462 9.08572 8.29086 9.26907L14.9514 15.8257V25.7882C14.9514 26.1515 15.3398 26.3878 15.67 26.2254L18.3747 24.8941C18.7111 24.7285 18.9236 24.39 18.9236 24.0197V15.8257L25.5841 9.26907C25.7704 9.08572 25.875 8.83708 25.875 8.57781V7.51637Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.55273,
    y: 3,
    width: 19.848,
    height: 1,
    transform: "rotate(51.9468 9.55273 3)",
    fill: "#CD6EE5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.35449,
    y: 4.29102,
    width: 19.9888,
    height: 1,
    rx: 0.2,
    transform: "rotate(51.9468 9.35449 4.29102)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterReset);
export default __webpack_public_path__ + "static/media/filterReset.4df8e63117fd4911c1172564cf0f04a1.svg";
export { ForwardRef as ReactComponent };